export const STATUS_CHANGE_NOTE_STATUSES = {
    CLOSED: 'closed',
    EDITED: 'edited',
    PREFILLED: 'prefilled',
} as const;

export const STATUS_CHANGE_NOTE_ACTIONS = {
    CONTENT_CHANGED: 'contentChanged',
    RESET: 'reset',
    TOGGLED: 'toggled',
} as const;
